module.exports = __webpack_public_path__ + "img/logo.3949211e.png";